var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmazonRedshift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(6 4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#205B97",
    points: "18.314 30.931 33.698 34.594 33.698 5.779 18.314 9.442"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5193CE",
    d: "M33.697944,5.778864 L36.6282,7.243992 L36.6282,33.128676 L33.697944,34.593804 L33.697944,5.778864 Z M18.3141,30.930984 L2.930256,34.593804 L2.930256,5.778864 L18.3141,9.441684 L18.3141,30.930984 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#205B97",
    points: "2.93 5.779 0 7.244 0 33.129 2.93 34.594"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5193CE",
    points: "22.222 40.454 28.082 37.524 28.082 2.93 22.222 0 20.43 19.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#205B97",
    points: "14.406 40.454 8.546 37.524 8.546 2.93 14.406 0 16.198 19.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2E73B7",
    points: "14.406 0 22.301 0 22.301 40.373 14.406 40.373"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonRedshift);
export default __webpack_public_path__ + "static/media/AmazonRedshift.104a5c1c.svg";
export { ForwardRef as ReactComponent };